module.exports = __webpack_public_path__ + "media/images/front/advisory-lp/img_doctor02-3e4faf7686280813fd67eb1da6dbf46b.jpg";